import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  applyWebinar,
  getWebinar,
  getWebinarUser,
  updateWebinarLike,
  updateWebinarUserOrientation,
} from '../../../api/webinar/webinar';
import type { WebinarUserOrientation } from '../../../api/webinar/webinarUser.dto';

export const useWebinar = (title) => {
  const { data, isLoading } = useQuery({
    queryKey: ['webinar', title],
    queryFn: () => getWebinar(title),
    staleTime: 600000,
    gcTime: 600000,
  });
  return {
    webinar: data?.webinar,
    recommends: data?.recommends,
    isLoading: isLoading,
  };
};

export const useWebinarUser = (webinarId, onlineUserId) => {
  const { data, isLoading } = useQuery({
    queryKey: ['webinarUser', webinarId, onlineUserId],

    queryFn: () => {
      // todo: 잘 고쳐넣기
      if (!webinarId || !onlineUserId) {
        return null;
      }
      return getWebinarUser(webinarId, onlineUserId);
    },

    staleTime: 600000,
    gcTime: 600000,
  });
  return {
    isLoading,
    webinarUser: data,
  };
};

type WebinarLikeParams = {
  webinarId: string;
  onlineUserId: string;
  targetLike: boolean;
};
export const useUpdateWebinarLike = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: WebinarLikeParams) =>
      updateWebinarLike(
        params.webinarId,
        params.onlineUserId,
        params.targetLike,
      ),

    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['webinar'] });
      queryClient.invalidateQueries({ queryKey: ['webinarUser'] });
    },
  });
};

export type Survey = {
  question: string;
  answer: string;
};
type ApplyWebinarParams = {
  webinarId: string;
  onlineUserId: string;
  name: string;
  phone: string;
  email: string;
  survey: Survey[];
  question: string;
};
export const useApplyWebinar = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: ApplyWebinarParams) =>
      applyWebinar(
        params.webinarId,
        params.onlineUserId,
        params.name,
        params.phone,
        params.email,
        params.survey,
        params.question,
      ),

    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['webinarUser'] });
    },
  });
};

export const useUpdateWebinarUserOrientation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: {
      webinarId: string;
      onlineUserId: string;
      orientation: WebinarUserOrientation;
    }) =>
      updateWebinarUserOrientation(
        params.webinarId,
        params.onlineUserId,
        params.orientation,
      ),

    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['webinarUser'] });
    },
  });
};
